import { CommonWrapper } from '@kanda-libs/ks-component-ts';
import {
  ConfigWrapper,
  type HomeLinkProps,
} from '@kanda-libs/ks-design-library';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

export interface AppWrapperProps {
  children: JSX.Element;
}

const AppWrapper: FunctionComponent<AppWrapperProps> = function ({ children }) {
  return (
    <>
      <div id="modals" />
      <ConfigWrapper linkComponent={Link as FunctionComponent<HomeLinkProps>}>
        <CommonWrapper>{children}</CommonWrapper>
      </ConfigWrapper>
    </>
  );
};

export default AppWrapper;
